import { get } from './api'
import { GetOrderDeliveries200Response } from '../../model'

export const getOrderDeliveries = async (params?: {
    searchString?: string
    page?: number
    pageSize?: number
}): Promise<GetOrderDeliveries200Response> => {
    const { data } = await get('/order-deliveries', {
        params: {
            ...params
        }
    })

    return data
}

export const getOrderDeliveryDownloadLink = async (deliveryId: number) => {
    const { data } = await get(`/order-deliveries/${deliveryId}/download-link`)
    return data
}
